/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
import r from "../Widget.js";
import { css as e } from "../Feature/resources.js";
import { globalCss as i } from "../support/globalCss.js";
import { legacyIcon as c } from "../support/legacyIcon.js";
import { accessibleHandler as p } from "../support/decorators/accessibleHandler.js";
import { tsx as a } from "../support/jsxFactory.js";
import "../support/widgetUtils.js";
let n = class extends r {
  constructor() {
    super(...arguments), this.enabled = !0, this.iconClass = null, this.icon = null, this.title = "";
  }
  render() {
    const t = this.enabled ? 0 : -1,
      o = {
        [i.disabled]: !this.enabled,
        [i.interactive]: this.enabled
      };
    return a("div", {
      bind: this,
      class: this.classes(i.widgetButton, i.widget, o),
      onclick: this._triggerAction,
      onkeydown: this._triggerAction,
      role: "button",
      tabIndex: t,
      title: this.title
    }, a("span", {
      "aria-hidden": "true",
      class: this.classes(e.icon, this.iconClass ?? ""),
      role: "presentation"
    }), a("span", {
      class: c.fontFallbackText
    }, this.title));
  }
  _triggerAction() {
    this.action.call(this);
  }
};
t([o()], n.prototype, "action", void 0), t([o()], n.prototype, "enabled", void 0), t([o()], n.prototype, "iconClass", void 0), t([o()], n.prototype, "icon", void 0), t([o()], n.prototype, "title", void 0), t([p()], n.prototype, "_triggerAction", null), n = t([s("esri.widgets.IconButton")], n);
const l = n;
export { l as default };